import { useState } from "react";
import { AddStaff } from "./add-staff-dialog";
import { EditStaffDialog } from "./edit-staff-dialog";
import { DeleteStaffDialog } from "./delete-staff-dialog";
import StaffTable from "./staff-table";
import type { Staff } from "@/types/staff/api-types/staff-types";

export const StaffTabContent = () => {
  const [selectedStaff, setSelectedStaff] = useState<Staff | null>(null);
  const [isEditDialogOpen, setIsEditDialogOpen] = useState(false);
  const [staffToDelete, setStaffToDelete] = useState<Staff | null>(null);
  const [isDeleteDialogOpen, setIsDeleteDialogOpen] = useState(false);

  const handleStaffClick = (staff: Staff) => {
    setSelectedStaff(staff);
    setIsEditDialogOpen(true);
  };

  const handleEditDialogClose = (open: boolean) => {
    setIsEditDialogOpen(open);
    if (!open) {
      setSelectedStaff(null);
    }
  };

  const handleDeleteClick = (staff: Staff) => {
    setStaffToDelete(staff);
    setIsDeleteDialogOpen(true);
  };

  const handleDeleteDialogClose = (open: boolean) => {
    setIsDeleteDialogOpen(open);
    if (!open) {
      setStaffToDelete(null);
    }
  };

  return (
    <div className="mt-5">
      <div className="flex justify-end mb-4 pr-4">
        <AddStaff />
      </div>
      <StaffTable
        onStaffClick={handleStaffClick}
        onDeleteClick={handleDeleteClick}
      />
      {selectedStaff && (
        <EditStaffDialog
          staff={selectedStaff}
          open={isEditDialogOpen}
          onOpenChange={handleEditDialogClose}
        />
      )}
      {staffToDelete && (
        <DeleteStaffDialog
          staff={staffToDelete}
          open={isDeleteDialogOpen}
          onOpenChange={handleDeleteDialogClose}
        />
      )}
    </div>
  );
};
